const LOGOS = {
    ARBITRIP: 'https://s3.amazonaws.com/arbitrip/logos/arbitrip_logo.png',
    LETSTAY: 'https://arbitrip.s3.us-east-1.amazonaws.com/theme/letstay/logo.svg',
    HTZ: 'https://i.imgur.com/bBrfEPu.png',
};

module.exports = {
    LOGOS,
};
